export default __webpack_public_path__ + "static/media/star-fill.6430150c.svg";